import { IObject } from '../types';
import { IsEqualTo } from './FormValidation';
import {
  hasLowercaseLetter,
  hasNumber,
  hasUppercaseLetter,
  maxLength,
  minLength,
} from './Validator';

export enum PasswordValidationMessage {
  NotEqual = "Passwords do not match, please check that you've entered and confirmed your new password correctly!",
  LengthExceeded = 'Password must be less than 72 characters long.',
  // eslint-disable-next-line max-len
  NotSecure = 'Password must be at least 8 characters long and include lowercase letters, uppercase letters, and numbers.',
}

export const isPasswordSecure = (password: string) =>
  minLength(password, 8) &&
  hasLowercaseLetter(password) &&
  hasUppercaseLetter(password) &&
  hasNumber(password);

export const passwordValidation = (password: string, fieldName: string): IObject => {
  const errors: IObject = {};
  if (!isPasswordSecure(password)) {
    errors[fieldName] = PasswordValidationMessage.NotSecure;
  }
  if (!maxLength(password, 72)) {
    errors[fieldName] = PasswordValidationMessage.LengthExceeded;
  }
  return { ...errors };
};

export const repeatedPasswordValidation = (
  password: string,
  confirmedPassword: string,
  fieldName: string
): IObject => {
  const errors: IObject = {
    ...passwordValidation(confirmedPassword, fieldName),
  };

  if (IsEqualTo(confirmedPassword, password)) {
    errors[fieldName] = PasswordValidationMessage.NotEqual;
  }

  return { ...errors };
};
